export default {
    route: {
        hidden: true,
        meta: {
            title: '用户信息',
            auth: "sign",
        }
    }
}
